import { Cancel01Icon } from '@hugeicons/react'

export type ResourceActiveFilterChip = {
  id: string
  label: string
}

type ResourceActiveFilterChipsProps = {
  chips: ResourceActiveFilterChip[]
  onRemove: (id: string) => void
  className?: string
}

/** Chips dos filtros avançados ativos — remoção individual. */
export const ResourceActiveFilterChips = ({
  chips,
  onRemove,
  className
}: ResourceActiveFilterChipsProps) => {
  if (chips.length === 0) return null

  return (
    <div className={className ?? 'flex flex-wrap gap-1.5'}>
      {chips.map(chip => (
        <span
          key={chip.id}
          className="inline-flex items-center gap-1 rounded-full bg-brand/10 px-2.5 py-1 text-2xs font-semibold text-brand"
        >
          {chip.label}
          <button
            type="button"
            onClick={() => onRemove(chip.id)}
            className="flex items-center justify-center rounded-full p-0.5 transition-colors hover:bg-brand/20"
            aria-label={`Remover filtro: ${chip.label}`}
          >
            <Cancel01Icon size={10} aria-hidden />
          </button>
        </span>
      ))}
    </div>
  )
}

ResourceActiveFilterChips.displayName = 'ResourceActiveFilterChips'
